import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
// Faz BN (2026-05-10): Tema sistemi — design tokens + light/dark/system mode
import { ThemeModeProvider } from './theme';

// Global unhandled error/promise handler — devtools yoksa bile log alalım
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    console.error('[window.error]', e.error || e.message, e.filename + ':' + e.lineno);
  });
  window.addEventListener('unhandledrejection', (e) => {
    console.error('[unhandledrejection]', e.reason);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode kaldırıldı: ErrorBoundary'i çift-render eden + bazı 3rd-party
  // lib'lerle effect'leri 2 kez çalıştırarak gizli hata maskeliyordu.
  <ErrorBoundary>
    <ThemeModeProvider>
      <App />
    </ThemeModeProvider>
  </ErrorBoundary>
);
